import React from 'react';
import {ZoomClient} from './media-context';
export default React.createContext<ZoomClient>(null as any);
